<!-- Begin page -->
<div id="wrapper">
    <app-topnav *ngIf="topNav"></app-topnav>
    <app-sidebar ></app-sidebar>
    <!-- <app-sidebar *ngIf="sidebar"></app-sidebar> -->
    <!-- <app-sidebar-user *ngIf="sidebarUser"></app-sidebar-user> -->
    <!-- Start Page Content here -->
    <div class="content-page">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div> <!-- End Page content --> 
</div><!-- End wrapper -->


